module.exports = __webpack_public_path__ + "static/media/39610031-7mF0wSgs.412fcf43.JPG";